import {
    ActivityCategory,
    ActivityRecordType,
    TaskTypeId,
    TouchpointId,
} from "@sp-crm/core";
import {
    activityTypeChoicesForRecordType,
    ActivityTypeOption,
} from "components/tasks/activity-type-options";
import { TouchpointEditor } from "components/tasks/touchpoint-editor";
import { SecondaryCompactButton } from "components/ui/secondary-button";
import React, { useCallback, useState } from "react";

export interface TouchpointTypeTarget {
    touchpointId: TouchpointId;
    category: ActivityCategory;
    taskTypeId: TaskTypeId | null;
    note: string | null;
}

interface TouchpointTypeCellProps {
    target: TouchpointTypeTarget;
    recordType: ActivityRecordType | null;
    activityTypes: ActivityTypeOption[];
    onSaved: () => Promise<void>;
}

const triggerLabel = (target: TouchpointTypeTarget, hasChoices: boolean): string => {
    if (target.taskTypeId) {
        return "Edit";
    }
    return hasChoices ? "Set a type" : "Add a note";
};

export const TouchpointTypeCell: React.FC<TouchpointTypeCellProps> = ({
    target,
    recordType,
    activityTypes,
    onSaved,
}) => {
    const [isEditing, setIsEditing] = useState(false);
    const startEditing = useCallback(() => setIsEditing(true), []);
    const stopEditing = useCallback(() => setIsEditing(false), []);

    const hasChoices =
        activityTypeChoicesForRecordType(
            activityTypes,
            target.category,
            recordType,
            target.taskTypeId,
        ).length > 0;

    return (
        <>
            <SecondaryCompactButton onClick={startEditing}>
                {triggerLabel(target, hasChoices)}
            </SecondaryCompactButton>
            {isEditing ? (
                <TouchpointEditor
                    target={target}
                    recordType={recordType}
                    activityTypes={activityTypes}
                    onSaved={onSaved}
                    onClose={stopEditing}
                />
            ) : null}
        </>
    );
};
